export enum NotificacionType {
    ACTIVAR_CUENTA = 100,
    ACTIVAR_CUENTA_PARA_SOLICITUD_CITA = 100,
    ACTIVAR_CUENTA_PARA_PAGO_EN_LINEA = 105
}